import { COLORS } from '../enums/generic'
import { IMPORT_TYPES } from '../classes/library'

// Note: also in Companion App and backend
export const REKORDCLOUD_COLOR_HEX_MAP: { [key: string]: string } = {
  [COLORS.Red_Dark]: '#9e1006',
  [COLORS.Red]: '#e60e0e',
  [COLORS.Red_Light]: '#f2665c',
  [COLORS.Red_Orange]: '#e84315',
  [COLORS.Orange]: '#e88915',
  [COLORS.Beige]: '#ffe194',
  [COLORS.Yellow_Dark]: '#cccc00',
  [COLORS.Yellow]: '#f5f50c',
  [COLORS.Lime]: '#bae815',
  [COLORS.Green_Light]: '#adf55f',
  [COLORS.Green]: '#7fe80e',
  [COLORS.Green_Dark]: '#4b8c06',
  [COLORS.Teal]: '#12de78',
  [COLORS.Aqua]: '#12deca',
  [COLORS.Aqua_Dark]: '#099486',
  [COLORS.Blue_Light]: '#2fa8ed',
  [COLORS.Blue]: '#1058de',
  [COLORS.Blue_Dark]: '#06268f',
  [COLORS.Blue_Violet]: '#651ee8',
  [COLORS.Violet]: '#901ee8',
  [COLORS.Violet_Light]: '#b566f2',
  [COLORS.Magenta]: '#e60ede',
  [COLORS.Magenta_Dark]: '#82077d',
  [COLORS.Magenta_Red]: '#de105c',
  [COLORS.Grey_Light]: '#adadad',
  [COLORS.Grey_Dark]: '#5c5c5c',
  [COLORS.Black]: '#000000',
  [COLORS.White]: '#ffffff'
}

// Note: also in Companion App and backend
export const DVS_COLORS: { [key: string]: COLORS[] } = {
  [IMPORT_TYPES.Rekordbox]: [
    COLORS.Red,
    COLORS.Blue,
    COLORS.Violet,
    COLORS.Orange,
    COLORS.Yellow,
    COLORS.Green,
    COLORS.Aqua,
    COLORS.Magenta
  ],

  [IMPORT_TYPES.Serato]: [
    COLORS.Magenta,
    COLORS.Magenta_Dark,
    COLORS.Magenta_Red,
    COLORS.Red,
    COLORS.Red_Orange,
    COLORS.Orange,
    COLORS.Yellow,
    COLORS.Lime,
    COLORS.Green,
    COLORS.Green_Dark,
    COLORS.Green_Light,
    COLORS.Teal,
    COLORS.Aqua,
    COLORS.Blue_Light,
    COLORS.Blue,
    COLORS.Blue_Dark,
    COLORS.Violet,
    COLORS.Violet_Light,
    COLORS.Grey_Light,
    COLORS.Black,
    COLORS.White
  ],

  [IMPORT_TYPES.Traktor]: [
    COLORS.Yellow,
    COLORS.Orange,
    COLORS.Red,
    COLORS.Green,
    COLORS.Blue,
    COLORS.Violet,
    COLORS.Magenta
  ],

  [IMPORT_TYPES.VirtualDJ]: [
    COLORS.Red_Dark,
    COLORS.Red,
    COLORS.Red_Light,
    COLORS.Beige,
    COLORS.Yellow_Dark,
    COLORS.Yellow,
    COLORS.Green_Light,
    COLORS.Green,
    COLORS.Green_Dark,
    COLORS.Aqua,
    COLORS.Aqua_Dark,
    COLORS.Blue_Light,
    COLORS.Blue,
    COLORS.Blue_Dark,
    COLORS.Magenta,
    COLORS.Magenta_Dark,
    COLORS.Grey_Light,
    COLORS.Grey_Dark,
    COLORS.Black,
    COLORS.White
  ],

  [IMPORT_TYPES.EnginePrime]: [
    COLORS.Yellow,
    COLORS.Orange,
    COLORS.Violet,
    COLORS.Red,
    COLORS.Lime,
    COLORS.Green,
    COLORS.Aqua,
    COLORS.Blue
  ]
}
